import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const MAX_PINS = 5;
const MAX_RECENTS = 3;

// Default pins — acțiuni frecvente pentru utilizatorii noi
const DEFAULT_PINS = [
  '/facturi/nou',
  '/proforme/nou',
  '/receptie',
  '/cheltuieli/nou',
];

interface SidebarPrefsStore {
  pinnedHrefs: string[];
  recentHrefs: string[];
  togglePin: (href: string) => void;
  trackVisit: (href: string) => void;
}

export const useSidebarPrefsStore = create<SidebarPrefsStore>()(
  persist(
    (set) => ({
      pinnedHrefs: DEFAULT_PINS,
      recentHrefs: [],
      togglePin: (href) =>
        set((state) => {
          const isPinned = state.pinnedHrefs.includes(href);
          if (isPinned) {
            return { pinnedHrefs: state.pinnedHrefs.filter((h) => h !== href) };
          }
          // Enforce max 5; dacă deja sunt 5, scoate primul (FIFO)
          const next = [...state.pinnedHrefs, href].slice(-MAX_PINS);
          return { pinnedHrefs: next };
        }),
      trackVisit: (href) =>
        set((state) => {
          // Exclude dashboard root și paths irelevante
          if (href === '/' || href === '/login' || href.startsWith('/auth')) {
            return state;
          }
          // Dedupe + cap la MAX_RECENTS
          const deduped = [href, ...state.recentHrefs.filter((h) => h !== href)];
          return { recentHrefs: deduped.slice(0, MAX_RECENTS) };
        }),
    }),
    {
      name: 'sf-sidebar-prefs',
      storage: createJSONStorage(() => (typeof window !== 'undefined' ? localStorage : ({
        getItem: () => null, setItem: () => {}, removeItem: () => {},
      } as Storage))),
      partialize: (state) => ({ pinnedHrefs: state.pinnedHrefs, recentHrefs: state.recentHrefs }),
    }
  )
);
